import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './teaser-info.scss';

const TeaserInfo = ({
  styleModifier,
  text,
  children,
  ...additionalAttributes
}) => (
  <span
    className={classNames('teaser-info', styleModifier)}
    {...additionalAttributes}>
    {text}
    {children}
  </span>
);

TeaserInfo.propTypes = {
  styleModifier: PropTypes.string,
  text: PropTypes.string,
};

export default TeaserInfo;
